import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

import { DEFAULT_MARKS } from '../../../components/Messenger/constants/defaultMarks';

export const addNewMark = createAsyncThunk(
  'messenger/addNewMark',
  async (data, { signal, rejectWithValue, getState }) => {
    try {
      const source = axios.CancelToken.source();
      signal.addEventListener('abort', () => {
        source.cancel();
      });

      try {
        // TODO: replace with api call (return updated filter list)
        const filterList = [
          {
            name: DEFAULT_MARKS.ALL,
            count: getState().messenger.conversations.length,
          },
          {
            name: data.name,
            count: 1,
          },
        ];

        return Promise.resolve(filterList);
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const addNewMarkExtraReducers = builder => {
  builder
    .addCase(addNewMark.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.newMark.request,
        action,
        action.meta.arg.name,
      );
    })
    .addCase(addNewMark.fulfilled, (state, action) => {
      onMatchedRequest(
        state.newMark.request[action.meta.arg.name],
        action,
        () => {
          state.filters.list = action.payload;
        },
      );
    })
    .addCase(addNewMark.rejected, (state, action) => {
      handleRequestRejection(
        state.newMark.request[action.meta.arg.name],
        action,
      );
    });
};
